import { track } from "@/v1-console/analytics"

export function trackProjectsMenuShown() {
  track("Project_Selector_MenuShown", {
    module: "Project_Selector",
    action: "MenuShown",
    issueId: 6505,
    sprintNo: 23
  })
}

export function trackActiveProjectChanged() {
  track("Project_Selector_Changed", {
    module: "Project_Selector",
    action: "Changed",
    issueId: 6505,
    sprintNo: 23
  })
}
